import React, { Fragment } from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import Play from '@material-ui/icons/PlayArrow';
import Check from '@material-ui/icons/Check';
import Delete from '@material-ui/icons/Close';
import DotIcon from '@material-ui/icons/Lens';
import Collapse from '@material-ui/core/Collapse';
import ListItem from '@material-ui/core/ListItem';
import TextField from '@material-ui/core/TextField';
import ListItemText from '@material-ui/core/ListItemText';
import AddBoxRounded from '@material-ui/icons/AddBoxRounded';
import FormHelperText from '@material-ui/core/FormHelperText';

import GhaAwbLocationPcs from '../../../../models/GhaAwbLocationPcs';
import GhaPickupStatusAwb from '../../../../models/GhaPickupStatusAwb';

import ghaPickupStatusStyles from './ghaPickupStatus.module.css';
import commonStyles from '../../../common/common.module.css';
import { isNumber } from 'util';
import { Button } from '@material-ui/core';

const TEXT_FIELD_PADDINGS: string = '10px 3px 7px 10px';
const TEXT_FIELD_FONT_SIZE: string = '0.8125rem';
const styles = (theme: Theme) =>

  createStyles({
    root: {
      width: '85%'
    },
    cursor: {
      cursor: 'pointer',
    },
    locIcon: {
      marginTop: '28px',
    },
    nested: {
      display: 'flex',
      justifyContent: 'space-between',
      paddingLeft: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingTop: 0,
    },
    addBox: {
      color: 'var(--primaryblue)',
      position: 'absolute',
      top: '13px',
      right: 0,
      zIndex: 1,
      fontSize: 26
    },
    play: {
      marginTop: 20,
      color: 'var(--primaryblue)',
      marginLeft: '-7px'
    },
    playRotate: {
      transform: 'rotate(90deg)'
    },
    ListItem: {
      borderBottom: '1px solid rgba(224, 224, 224, 1)',
      paddingBottom: 5
    },
    ListItemText: {
      fontSize: TEXT_FIELD_FONT_SIZE
    },
    dotIconCommon: {
      fontSize: 14,
      position: 'absolute',
      top: 20,
      right: 35
    },
    green: {
      color: 'green',
    },
    red: {
      color: 'red'
    },
    locationInput: {
     paddingRight: '10px'
    },

    error: {
      color: 'red',
      marginTop: 0
    },
    defaultButton: {
      top: '17px',
      right:' 55px',
      position: 'absolute',
      fontSize: '0px',
      background: 'none !important',
      border: 'none',
      padding: '0!important',
      fontFamily: 'arial, sans-serif',
      color: '#069',
      textDecoration: 'underline',
      cursor: 'auto',
      zIndex: 999
    },
    mr90:{
      marginRight: '90px',
    }
  });

interface GhaAwbLocationDataProps {
  classes: any;
  locationsAndPcs: GhaPickupStatusAwb;
  handleExpandChange: (expandType: string, forceOpen?: boolean) => void;
  expandLocationData: boolean;
  showNewLocationPcsRow: boolean;
  tempLocationAndPcs: { pieces: number | string; location: string; };
  handleInputValueChange: (event: React.ChangeEvent<HTMLInputElement>, inputType: string) => void;
  addNewLocationAndPcsRow: () => void;
  doAddLocationAndPcs: (defaultOption: boolean) => void;
  doRemoveLocationAndPcs: (element?: GhaAwbLocationPcs) => void;
  pcs_error: boolean;
  updateLocations: boolean;
};

const ghaAwbLocationData = (props: GhaAwbLocationDataProps) => {

  const { classes } = props;
  const dotStatusClasses: string = [classes.dotIconCommon, props.locationsAndPcs.wh_location.status === 'stored' ? classes.green : classes.red].join(' ');

  return (

    <div className={ ghaPickupStatusStyles.mainWrapper } >
      { props.expandLocationData
        ? <Play className={ [classes.play, classes.playRotate, classes.cursor ].join(' ') } onClick={ () => props.handleExpandChange('locationData') } />
        : <Play className={ [classes.play, classes.cursor].join(' ') } onClick={ () => props.handleExpandChange('locationData') } />
      }
      <List
        component="nav"
        aria-labelledby="nested-list-subheader"
        className={ classes.root }
      >
       { props.locationsAndPcs.wh_location.status !== 'stored' && <Button
          className={ classes.defaultButton }
          onClick={ () => props.doAddLocationAndPcs(true) }
        >Default</Button>}
        <DotIcon className={ dotStatusClasses } />
       
        <AddBoxRounded
          className={ [classes.addBox, classes.cursor].join(' ') }
          onClick={ 
            () =>  {
              if (props.updateLocations ) {
              props.addNewLocationAndPcsRow();
              props.handleExpandChange('locationData', true);
              } else {
                return;
              }
            } 
          } 
        />
        <ListItem className={ classes.ListItem } >
          <ListItemText classes={{ primary: classes.ListItemText }} className={ classes.mr90 } primary="W/H Location Data" />
        </ListItem>

        <Collapse in={ props.expandLocationData } timeout="auto" unmountOnExit >
          <List component="time" disablePadding >

            { props.locationsAndPcs.wh_location.data.map((locationAndPcs: GhaAwbLocationPcs, index: number) => {

              return <Fragment key={ index }>

                  <ListItem className={ classes.nested }>
                    <div className={ commonStyles.inputLabelWrapper } >
                      <label className={ commonStyles.inputLabel }> Location </label>
                      <TextField
                        className={ classes.locationInput }
                        value={ locationAndPcs.location }
                        label=""
                        variant="outlined"
                        inputProps={{ style: { fontSize: TEXT_FIELD_FONT_SIZE, padding: TEXT_FIELD_PADDINGS } }}
                        InputLabelProps={{ shrink: true }}
                      />
                    </div>

                    <div className={ commonStyles.inputLabelWrapper } >
                      <label className={ commonStyles.inputLabel }> PCS  </label>
                      <TextField
                        className={ classes.pcsInput }
                        value={ locationAndPcs.pieces }
                        label=""
                        variant="outlined"
                        inputProps={{ style: { fontSize: TEXT_FIELD_FONT_SIZE, padding: TEXT_FIELD_PADDINGS } }}
                        InputLabelProps={{ shrink: true }}
                        aria-describedby="pcs-helper-text"
                      />
                    </div>
                    <div style={{ width: 25 }}></div>
                    { props.updateLocations &&
                    <Delete className={ [classes.red, classes.cursor, classes.locIcon].join(' ') } onClick={ ()=> props.doRemoveLocationAndPcs(locationAndPcs) } />
                    }
                  </ListItem>

                </Fragment>
              })
            }

            { props.showNewLocationPcsRow &&
              <Fragment>
                <ListItem className={ classes.nested }>
                  <div className={ commonStyles.inputLabelWrapper } >
                    <label className={ commonStyles.inputLabel }> Location </label>
                    <TextField
                      className={ classes.locationInput }
                      value={ props.tempLocationAndPcs.location }
                      label=""
                      variant="outlined"
                      onChange={
                        (event: React.ChangeEvent<HTMLInputElement>) => {
                          props.handleInputValueChange(event, 'location');
                        }
                      }
                      inputProps={{ 
                        style: { fontSize: TEXT_FIELD_FONT_SIZE, padding: TEXT_FIELD_PADDINGS},
                      }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>

                  <div className={ commonStyles.inputLabelWrapper } >
                    <label className={ commonStyles.inputLabel }> PCS  </label>
                    <TextField
                      error={ props.pcs_error }
                      className={ classes.pcsInput }
                      value={ props.tempLocationAndPcs.pieces }
                      label=""
                      variant="outlined"
                      onChange={
                        (event: React.ChangeEvent<HTMLInputElement>) => {
                          props.handleInputValueChange(event, 'pieces');
                        }
                      }
                      inputProps={{ style: { fontSize: TEXT_FIELD_FONT_SIZE, padding: TEXT_FIELD_PADDINGS } }}
                      InputLabelProps={{ shrink: true }}
                      aria-describedby="pcs-helper-text"
                    />
                  </div>                 

                  { !props.tempLocationAndPcs.location &&
                    <Fragment>
                      <div style={{ width: 25 }}></div>
                      <Delete className={ [classes.red, classes.cursor, classes.locIcon].join(' ') } 
                      onClick={ () => props.doRemoveLocationAndPcs() }
                      />
                    </Fragment>
                  }
                  { props.tempLocationAndPcs.location &&
                    <Fragment>
                      { !props.pcs_error && isNumber(props.tempLocationAndPcs.pieces) &&
                        props.tempLocationAndPcs.pieces > 0 && props.tempLocationAndPcs.location !== ''
                        ? <Check
                            className={ [classes.green, classes.cursor, classes.locIcon].join(' ') }
                            onClick={ () => props.doAddLocationAndPcs(false) }
                          />
                        : <div style={{ width: 25 }}></div>
                      }
                      <Delete className={ [classes.red, classes.cursor, classes.locIcon].join(' ') } 
                      onClick={ () => props.doRemoveLocationAndPcs() } 
                      />
                    </Fragment>
                  }
                </ListItem>
                { props.pcs_error &&
                  <FormHelperText id="pcs-helper-text" className={ classes.error } >Exceeded number of Pcs for AWB.</FormHelperText>
                }
              </Fragment>
            }  

          </List>
        </Collapse>

      </List>
    </div>
  );
};

export default withStyles(styles)(ghaAwbLocationData);